// src/App.js

import React, { useState, useEffect } from 'react'; // Añadido useEffect si usas el sessionStorage
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// Páginas Públicas
import Landing from './pages/Landing';
import VerifyEmail from './pages/VerifyEmail';
import PricingPage from './pages/PricingPage';
import PaymentSuccess from './pages/PaymentSuccess';
import PaymentCancel from './pages/PaymentCancel'; // <-- CORREGIDO

// Páginas Protegidas
import ProtectedRoute from './components/ProtectedRoute';
import DesignStudio from './pages/DesignStudio';
import Settings from './pages/Settings';

// (Opcional) Página 404
// import NotFound from './pages/NotFound';

// --- Componente para la Protección por Contraseña ---
const SitePasswordGate = ({ children }) => {
    const VERCEL_PASSWORD = process.env.REACT_APP_SITE_PASSWORD;
    // Intenta recuperar el estado desde sessionStorage al inicio
    const getInitialAuthState = () => {
        if (!VERCEL_PASSWORD) return true; // Si no hay contraseña, permitir acceso
        try {
            return sessionStorage.getItem('site_authenticated') === 'true';
        } catch (e) {
            console.error("Error reading sessionStorage:", e);
            return false;
        }
    };

    const [isAuthenticated, setIsAuthenticated] = useState(getInitialAuthState);
    const [inputValue, setInputValue] = useState('');
    const [error, setError] = useState('');

    // Si no hay contraseña configurada en Vercel Y no estamos ya autenticados por sessionStorage
    if (!VERCEL_PASSWORD && !isAuthenticated) {
         console.warn("AVISO DESARROLLO: REACT_APP_SITE_PASSWORD no está configurada. Acceso permitido.");
         return <>{children}</>;
    }

    const handleLogin = () => {
        if (inputValue === VERCEL_PASSWORD) {
            setIsAuthenticated(true);
            setError('');
            // Guardar estado en sessionStorage para persistencia en la sesión
            try {
                 sessionStorage.setItem('site_authenticated', 'true');
            } catch (e) {
                 console.error("Error writing to sessionStorage:", e);
            }
        } else {
            setError('Contraseña incorrecta.');
            setInputValue('');
        }
    };

    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            handleLogin();
        }
    };

    // Renderizar pantalla de login solo si se requiere contraseña y no está autenticado
    if (VERCEL_PASSWORD && !isAuthenticated) {
        return (
            <div className="flex min-h-screen items-center justify-center bg-slate-950 text-white p-4">
                <div className="bg-gray-800 p-6 md:p-8 rounded-lg shadow-xl border border-gray-700 w-full max-w-sm">
                    <h2 className="text-xl font-semibold mb-4 text-center text-purple-400">Acceso Protegido</h2>
                    <p className="text-sm text-gray-400 mb-4 text-center">Este sitio está actualmente en desarrollo.</p>
                    <input
                        type="password"
                        placeholder="Introduce la contraseña de acceso"
                        className="border border-gray-600 bg-gray-700 text-white p-2 rounded mb-3 w-full focus:outline-none focus:ring-2 focus:ring-purple-500"
                        value={inputValue}
                        onChange={(e) => setInputValue(e.target.value)}
                        onKeyPress={handleKeyPress}
                        autoFocus // Añadir autofocus para comodidad
                    />
                    {error && <p className="text-red-500 text-xs mb-3 text-center">{error}</p>}
                    <button
                        className="bg-purple-600 hover:bg-purple-700 text-white px-4 py-2 rounded w-full transition-colors duration-200"
                        onClick={handleLogin}
                    >
                        Entrar
                    </button>
                </div>
            </div>
        );
    }

    // Si está autenticado o no se requiere contraseña, renderiza la aplicación real
    return <>{children}</>;
};

// --- Componente Principal de la Aplicación ---
function AppContent() {
    return (
        <Router>
            <Routes>
                {/* --- Rutas Públicas --- */}
                <Route path="/" element={<Landing />} />
                <Route path="/verify-email" element={<VerifyEmail />} />
                <Route path="/pricing" element={<PricingPage />} />
                <Route path="/payment-success" element={<PaymentSuccess />} />
                <Route path="/payment-cancel" element={<PaymentCancel />} />

                {/* --- Rutas Protegidas --- */}
                <Route element={<ProtectedRoute />}>
                    <Route path="/DesignStudio" element={<DesignStudio />} />
                    <Route path="/settings" element={<Settings />} />
                </Route>

                {/* --- Fallback (opcional) --- */}
                {/* <Route path="*" element={<NotFound />} /> */}
            </Routes>
        </Router>
    );
}

// --- Componente Raíz que aplica el Gate ---
function App() {
  return (
    // Envuelve TODO el contenido de la aplicación con el SitePasswordGate
    <SitePasswordGate>
      <AppContent />
    </SitePasswordGate>
  );
}

export default App;